module.exports = __webpack_public_path__ + "assets/5cf0d1d2ea07164f1991cd17e6343aac.svg";